import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import CHILE_OFFER_FLOW_STEP_IDS from '@fingo/lib/constants/factoring/chile-offer-flow-step-ids';
import useStepIndexFromConditions from '@fingo/lib/hooks/useStepIndexFromConditions';

const useAvailableOffersTutorial = (stepsConditions = [], stepsCallbacks = {}) => {
  const { t } = useTranslation();
  const steps = useMemo(
    () => [
      {
        id: CHILE_OFFER_FLOW_STEP_IDS.SELECT_INVOICES,
        title: 'Selecciona tus facturas y empieza tu anticipo',
        description: '',
        onBack: () => {},
      },
      {
        id: CHILE_OFFER_FLOW_STEP_IDS.SELECT_DATES,
        title: 'Ingresa fechas de pago',
        description: '',
        labelMaxWidth: 100,
        onBack: stepsCallbacks.handleBackToBeginAdvancePayment,
      },
      {
        id: CHILE_OFFER_FLOW_STEP_IDS.CREDENTIAL_PROVIDER_SELECTOR,
        title: 'Selecciona tu facturador',
        labelMaxWidth: 105,
        description: '',
        onBack: stepsCallbacks.handleBackToDateSelection,
      },
      {
        id: CHILE_OFFER_FLOW_STEP_IDS.CESSION_TYPE_SELECTOR,
        title: 'Elige cómo quieres ceder',
        description: '',
        onBack: stepsCallbacks.handleBackInCessionSubStep ?? (() => {}),
      },
      {
        id: CHILE_OFFER_FLOW_STEP_IDS.FINISH_CESSION,
        title: 'Termina el proceso de cesión',
        description: '',
        onBack: stepsCallbacks.handleBackInCessionSubStep ?? (() => {}),
      },
    ],
    [t, stepsCallbacks],
  );

  const activeStep = useStepIndexFromConditions(stepsConditions);

  return { steps, activeStep, isCompleted: false };
};

export default useAvailableOffersTutorial;
